import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import routes from 'components/App/components/routes';
import Cellar from './Cellar';

const CellarRoutes = [
    <Route
        path={routes.cellarFuncTable}
        key="cellar-table-selected"
        element={<Cellar />}
    />,
    <Route
        path={routes.cellarFunc}
        key="cellar-domain-selected"
        element={<Cellar />}
    />,
    <Route
        path={routes.cellar}
        key="cellar-domain-redirect"
        element={<Navigate to="/cellar/global" replace />}
    />,
];
export default CellarRoutes;
